<div class="toast-container">
  @for (toast of toasts; track toast; let i = $index) {
    <div
      tabindex="0"
      role="alert"
      aria-live="polite"
      class="toast {{
        toast.type
      }} animate__animated animate__fadeIn animate__faster focus-visible"
      [ngClass]="{
        animate__fadeOut: (closedId$ | async) === toast.id,
      }"
    >
      <mat-icon>{{ getIcon(toast.type) }}</mat-icon>
      <span>{{ toast.text }}</span>
      <button aria-label="close" mat-icon-button (click)="close(toast.id)">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  }
</div>
